import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import LoginForm from '../LoginForm';

const MarketplaceRedirect: React.FC = () => {
  const { isAuthenticated } = useAuth();
  
  // If user is authenticated, redirect to skills page
  if (isAuthenticated) {
    return <Navigate to="/marketplace/skills" replace />;
  }
  
  // If user is not authenticated, show login form
  return <LoginForm />;
};

export default MarketplaceRedirect;